import { LIMIT_MAX } from '@/constants';
import { fetcher } from '@/services/graphql/fetcher/index';
import type { AnyObj } from '@/types';
import {
  fetchActiveCustomerDocument,
  fetchCreateCustomAddressDocument,
  fetchDeleteAddressDocument,
  fetchRegionsJsonDocument,
  fetchUpdateAddressDocument,
} from '../graphql/docs';

/**
 * 获取地址列表
 */
export const fetchAddressList = async () => {
  const res = await fetcher.query(fetchActiveCustomerDocument, {
    variables: { take: LIMIT_MAX },
  });
  return res.data.value?.activeCustomer?.addresses;
};

/**
 * 获取地址省市区数据资源
 * @param level
 * @param parentCode
 * @returns
 */
export const fetchRegionsJsons = async (regionNames: string[]) => {
  const res = await fetcher.query(fetchRegionsJsonDocument, {
    variables: { regionNames },
  });
  return res.data.value?.getRegionsJson;
};

/**
 * 添加地址
 * @param input
 */
export const fetchCreateAddress = async (input: AnyObj) => {
  const res = await fetcher.mutation(fetchCreateCustomAddressDocument, {
    input,
  });
  return res.data?.createCustomerAddress;
};

/**
 * 更新地址
 * @param input
 */
export const fetchUpdateAddress = async (input: AnyObj) => {
  const res = await fetcher.mutation(fetchUpdateAddressDocument, {
    input,
  });
  return res.data?.updateCustomerAddress;
};

/**
 * 删除地址
 * @param id
 */
export const fetchDeleteAddress = async (id: string) => {
  const res = await fetcher.mutation(fetchDeleteAddressDocument, {
    id,
  });
  return res.data?.deleteCustomerAddress;
};

/**
 * 获取省市区地址数据
 */
export const fetchRegionsJson = async () => {
  return new Promise((reslove, reject) => {
    uni.request({
      url: `https://cdn.s3.mall.startcatcher.com/public/regions.json`,
      dataType: 'json',
      success: (res) => reslove(res.data),
      fail: (error) => reject(error),
    });
  });
};
